const getRangeFromPoint = (x: number, y: number): Range | null => {
  if (document.caretRangeFromPoint) {
    const range = document.caretRangeFromPoint(x, y);
    return range;
  }

  // Firefox only
  if (document.caretPositionFromPoint) {
    const caretPosition = document.caretPositionFromPoint(x, y);
    if (caretPosition) {
      const range = document.createRange();
      range.setStart(caretPosition.offsetNode, caretPosition.offset);
      range.setEnd(caretPosition.offsetNode, caretPosition.offset);
      return range;
    }
  }

  return null;
};

export default getRangeFromPoint;
